import ContactMail from "@mui/icons-material/ContactMail";
import PhotoLibrary from "@mui/icons-material/PhotoLibrary";
import Portrait from "@mui/icons-material/Portrait";
import { SidebarLink, SidebarSectionTitle } from "@tngtech/tng-ui";
import { useContext } from "react";
import { useLocation } from "react-router";
import { OtherAppSidebarLink } from "../../src/components/OtherAppSidebarLink";
import { RuntimeConfigContext } from "../../src/config/RuntimeConfigContext";
import { usePortraitsTranslator } from "./i18n/translator";
import { useGetMe } from "./useGetMe";

export const PortraitsSidebar = () => {
  const translator = usePortraitsTranslator();
  const { pathname } = useLocation();
  const { appUrls } = useContext(RuntimeConfigContext);
  const { data: me } = useGetMe();

  return (
    <>
      <SidebarLink
        title={translator("navOwnPortrait")}
        href="/"
        icon={Portrait}
        selected={pathname === "/"}
      />
      <OtherAppSidebarLink
        title={translator("navAddressCollection")}
        href={appUrls.addressCollection}
        icon={ContactMail}
        newTabHint={translator("opensInNewTab")}
      />
      {me?.isAdmin && (
        <>
          <SidebarSectionTitle title={translator("navAdmin")} />
          <SidebarLink
            title={translator("reviewPortraits")}
            href="/admin"
            icon={PhotoLibrary}
            selected={pathname.startsWith("/admin")}
          />
        </>
      )}
    </>
  );
};
